import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { getIconColorSVGFill } from '../../tools/colors.js';
import css_248z from './icons.styles.css.js';

let SpinnerIcon = class SpinnerIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.color = 'currentColor';
        this.size = '24';
    }
    render() {
        return html `
      <svg
        width=${`${this.size}px`}
        height=${`${this.size}px`}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        part="spinner-icon"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0L12 2.18182C17.4224 2.18182 21.8182 6.57757 21.8182 12C21.8182 17.4224 17.4224 21.8182 12 21.8182C6.57757 21.8182 2.18182 17.4224 2.18182 12L0 12C0 18.6274 5.37258 24 12 24Z"
          fill=${this.color ? getIconColorSVGFill(this.color) : 'currentColor'}
        />
        <mask
          id="mask0_38_119"
          style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0L12 2.18182C17.4224 2.18182 21.8182 6.57757 21.8182 12C21.8182 17.4224 17.4224 21.8182 12 21.8182C6.57757 21.8182 2.18182 17.4224 2.18182 12L0 12C0 18.6274 5.37258 24 12 24Z"
            fill=${this.color
            ? getIconColorSVGFill(this.color)
            : 'currentColor'}
          />
        </mask>
        <g mask="url(#mask0_38_119)"></g>
      </svg>
    `;
    }
};
SpinnerIcon.styles = css `
    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    svg {
      animation: spin 1s linear infinite;
    }
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: String })
], SpinnerIcon.prototype, "color", void 0);
__decorate([
    property({ type: String })
], SpinnerIcon.prototype, "size", void 0);
SpinnerIcon = __decorate([
    customElement('spinner-icon')
], SpinnerIcon);
var SpinnerIcon$1 = SpinnerIcon;

export { SpinnerIcon$1 as default };
//# sourceMappingURL=spinnerIcon.js.map
